import React from "react";
import { Box, Button, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import AwardIcon from "../../components/Svgs/AwardIcon/AwardIcon";

const useStyles = makeStyles(theme => ({
  button: {
    padding: 0,
    marginBottom: theme.spacing(2)
  }
}));

export default function AwardButton({
  awardColor,
  icon,
  customIcon,
  awardType,
  awardTitle,
  handleAwardClicked
}) {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      maxWidth={200}
    >
      <Button
        className={classes.button}
        onClick={() => handleAwardClicked(awardTitle)}
        data-qa="award-button"
      >
        <AwardIcon
          icon={icon}
          awardTitle={awardTitle}
          hasBackground={!customIcon}
          customIcon={customIcon}
          awardColor={awardColor}
          awardType={awardType}
          width={200}
          height={200}
        />
      </Button>
      <Typography
        variant="subtitle1"
        align="center"
        data-qa="award-button-title"
      >
        {awardTitle}
      </Typography>
    </Box>
  );
}

AwardButton.propTypes = {
  icon: PropTypes.string,
  awardColor: PropTypes.string,
  awardTitle: PropTypes.string,
  awardType: PropTypes.string,
  customIcon: PropTypes.any,
  handleAwardClicked: PropTypes.func
};
